import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/icons/ic-chevron-left-area-outline-purple.svg")